export default "__VITE_ASSET__DSiPMXzz__"